module.exports = __webpack_public_path__ + "staticcomp/img/content_2.a654053.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/9/content_2.jpg
// module id = f3Te
// module chunks = 39